import {Component, EventEmitter, Input, OnDestroy, Output} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {LoadingController, ToastController} from '@ionic/angular';
import {Subject} from 'rxjs';
import {debounceTime, distinctUntilChanged} from 'rxjs/operators';
import {BaseClass} from 'src/app/shared/classes/base';
import {AuthService} from 'src/app/shared/services/auth.service';
import {TranslationService} from 'src/app/shared/services/translation.service';
import {Evaluation360Service} from '../../360-evaluation.service';
import {Evaluated360User} from '../../_interfaces/360-evaluation-user.interface';

type DisplayedUser = Evaluated360User & { isReopeningExpired: boolean,isReopenedByRefusal: boolean };
@Component({
    selector: 'app-360-evaluation-users-list',
    templateUrl: './users-list.component.html',
    styleUrls: ['./users-list.component.scss']
})
export class Evaluation360UsersListComponent extends BaseClass implements OnDestroy {

  @Input() set users(userList: Array<Evaluated360User>) {
    if(!userList) return;
    const userToDisplay = userList.map(user => {
        return {
            ...user,
            isReopeningExpired: user.reopeningDueDate? (new Date(user.reopeningDueDate).getTime() < Date.now()) : false,
            isReopenedByRefusal: user.reopeningDueDate? (new Date(user.reopeningDueDate).getTime() > 0) : false
            }
        });
    this._users = userToDisplay;
    this.displayedUsers = userToDisplay;
  }

    @Output() selectUser: EventEmitter<Evaluated360User> = new EventEmitter();
    @Output() reopenUser: EventEmitter<Evaluated360User> = new EventEmitter();

  public displayedUsers: Array<DisplayedUser> = [];
  public selectedUserId: string;
  public isAllowedToReopen: boolean = false;

  private _userRoles: Array<string> = [];
  private _cycleId: number;
  private _users: Array<DisplayedUser> = [];
  private _searchSubject: Subject<string> = new Subject();

    constructor(
        protected _toastController: ToastController,
        private _evaluationService: Evaluation360Service,
        protected _loadingController: LoadingController,
        private _authService: AuthService,
        private _activatedRoute: ActivatedRoute,
        protected _translationService: TranslationService
    ) {
        super(_toastController, _translationService);
        this._cycleId = parseInt(
            this._activatedRoute.snapshot.paramMap.get('cycleId'), 10
        );
        this._userRoles = this._authService.getUserRoles();
        if (this._userRoles.includes('Administrator') ||
            this._userRoles.includes('HR')) {
            this.isAllowedToReopen = true;
        }
        this._setSearchSubscription();
    }

    public updateSearch(searchTextValue: string): void {
        this._searchSubject.next(searchTextValue);
    }

  public setUser(user: DisplayedUser): void {
    if(user.isReopeningExpired) {
        return;
    }
    this.selectedUserId = user.userId;
    this.selectUser.emit( user );
  }

    private _setSearchSubscription() {
        this._searchSubject.pipe(
            distinctUntilChanged(),
            debounceTime(1000)
        ).subscribe((searchValue: string) => {
            if (searchValue) {
                this.displayedUsers = this._users.filter(user => {
                    return user.name.toLowerCase().includes(
                        searchValue.toLowerCase().trim()
                    );
                });
            } else {
                this.displayedUsers = this._users;
            }
        });
    }

    ngOnDestroy() {
        this.selectedUserId = '';
        this._searchSubject.unsubscribe();
    }

  public reopenEvaluation(user: DisplayedUser): void {
    if(user.isReopeningExpired) return;
    this._evaluationService.reopenValidation(
      this._cycleId, user.userId
    ).subscribe((response) => {
      this.reopenUser.emit();
      this.notifySuccess('performanceCycles.processReopened');
    }
    , (error) => this.notifyError(error) );
  }
}
